import React from "react";
import reactSVG from "../images/react.svg";
import tailwindSVG from "../images/tailwind.svg";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faEquals, faHeart } from "@fortawesome/free-solid-svg-icons";

function HowItWorks() {

  return (
    <div className="bg-gray-100 py-6 px-4">
      <div className="container mx-auto">
        <div className="text-center w-full lg:w-2/3 mx-auto">
          <h2 className="text-2xl md:text-4xl font-bold leading-tight mt-8">
            A match made in heaven
          </h2>
          <p className="text-lg py-2 text-gray-800 font-body">
            The most popular JS library meets the most popular CSS framework. <br/><br/>
            We transform Create-React-App projects into beautiful, conversion optimized, production-ready Tailwind styled landing pages.
          </p>
        </div>
        <div className="my-16 flex flex-col justify-center items-center sm:flex-row">
            <div className="h-20 w-20 m-10">
              <img src={reactSVG} alt="react-icon" />
            </div>
            <FontAwesomeIcon className="" icon={faPlus} size="2x" />
            <div className="h-20 w-20 m-10">
              <img src={tailwindSVG} alt="tailwind-icon" />
            </div>  
            <div data-aos="fade-down" className="sm:mb-6">
              <FontAwesomeIcon className="mr-10" icon={faEquals} size="2x" />
              <FontAwesomeIcon className="text-red-500" icon={faHeart} size="5x" />
            </div>
        </div>
      </div>
    </div>
  )
}

export default HowItWorks;